__turbopack_export_value__({
  "body-logo-18": "doctorCard-module-scss-module__uXCLKW__body-logo-18",
  "body-text-12": "doctorCard-module-scss-module__uXCLKW__body-text-12",
  "body-text-14": "doctorCard-module-scss-module__uXCLKW__body-text-14",
  "body-text-16": "doctorCard-module-scss-module__uXCLKW__body-text-16",
  "body-text-18": "doctorCard-module-scss-module__uXCLKW__body-text-18",
  "body-text-20": "doctorCard-module-scss-module__uXCLKW__body-text-20",
  "body-text-24": "doctorCard-module-scss-module__uXCLKW__body-text-24",
  "body-text-24-2": "doctorCard-module-scss-module__uXCLKW__body-text-24-2",
  "body-text-heading-2": "doctorCard-module-scss-module__uXCLKW__body-text-heading-2",
  "body-text-heading-3": "doctorCard-module-scss-module__uXCLKW__body-text-heading-3",
  "body-text-medium-14": "doctorCard-module-scss-module__uXCLKW__body-text-medium-14",
  "body-text-medium-16": "doctorCard-module-scss-module__uXCLKW__body-text-medium-16",
  "body-text-medium-18": "doctorCard-module-scss-module__uXCLKW__body-text-medium-18",
  "body-text-medium2-18": "doctorCard-module-scss-module__uXCLKW__body-text-medium2-18",
  "body-text2-14": "doctorCard-module-scss-module__uXCLKW__body-text2-14",
  "body-text2-16": "doctorCard-module-scss-module__uXCLKW__body-text2-16",
  "button": "doctorCard-module-scss-module__uXCLKW__button",
  "button-primary-text": "doctorCard-module-scss-module__uXCLKW__button-primary-text",
  "button-text": "doctorCard-module-scss-module__uXCLKW__button-text",
  "button2-text": "doctorCard-module-scss-module__uXCLKW__button2-text",
  "card": "doctorCard-module-scss-module__uXCLKW__card",
  "card-shadow": "doctorCard-module-scss-module__uXCLKW__card-shadow",
  "cardText": "doctorCard-module-scss-module__uXCLKW__cardText",
  "cardTitle": "doctorCard-module-scss-module__uXCLKW__cardTitle",
  "cardWrapper": "doctorCard-module-scss-module__uXCLKW__cardWrapper",
  "card__photoWrapper": "doctorCard-module-scss-module__uXCLKW__card__photoWrapper",
  "effect-menu": "doctorCard-module-scss-module__uXCLKW__effect-menu",
  "header-1": "doctorCard-module-scss-module__uXCLKW__header-1",
  "main-container": "doctorCard-module-scss-module__uXCLKW__main-container",
  "main-footer-container": "doctorCard-module-scss-module__uXCLKW__main-footer-container",
  "main-header-container": "doctorCard-module-scss-module__uXCLKW__main-header-container",
  "name": "doctorCard-module-scss-module__uXCLKW__name",
  "period": "doctorCard-module-scss-module__uXCLKW__period",
  "photo": "doctorCard-module-scss-module__uXCLKW__photo",
  "price": "doctorCard-module-scss-module__uXCLKW__price",
  "specialisations": "doctorCard-module-scss-module__uXCLKW__specialisations",
  "txt-12-bold": "doctorCard-module-scss-module__uXCLKW__txt-12-bold",
  "txt-14-bold": "doctorCard-module-scss-module__uXCLKW__txt-14-bold",
  "txt-14-bold-caps": "doctorCard-module-scss-module__uXCLKW__txt-14-bold-caps",
  "txt-14-med": "doctorCard-module-scss-module__uXCLKW__txt-14-med",
  "txt-16-bold": "doctorCard-module-scss-module__uXCLKW__txt-16-bold",
  "txt-16-med": "doctorCard-module-scss-module__uXCLKW__txt-16-med",
  "txt-18-bold": "doctorCard-module-scss-module__uXCLKW__txt-18-bold",
  "txt-18-medium": "doctorCard-module-scss-module__uXCLKW__txt-18-medium",
  "txt-18-medium-24": "doctorCard-module-scss-module__uXCLKW__txt-18-medium-24",
  "txt-24-semi": "doctorCard-module-scss-module__uXCLKW__txt-24-semi",
});
